import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const MotorbikeSVG: React.FunctionComponent<StyledProps> = ({
  width = 20,
  height = 15,
  display = "inline-flex",
  marginX = 0,
  ...props
}) => {
  return (
    <StyledContainer {...props}>
      <svg width="27" height="16" viewBox="0 0 27 16" fill="none">
        <path
          d="M21.6004 5.33316C21.0098 5.33316 20.3771 5.45815 19.8287 5.62481L18.4366 3.33322H21.9379C22.4863 3.33322 22.9503 2.91657 22.9503 2.33326V0.999967C22.9503 0.458318 22.4863 0 21.9379 0H19.9974C19.7021 0 19.449 0.124996 19.2381 0.333322L17.6773 2.08326L16.7071 0.499983C16.5383 0.208326 16.2008 0 15.8634 0H12.4886C12.109 0 11.8137 0.333322 11.8137 0.666645V1.33329C11.8137 1.70828 12.109 1.99993 12.4886 1.99993H15.2728L16.0743 3.33322H9.57793C8.8608 2.37492 7.72183 1.66661 5.40169 1.66661H3.03938C2.49099 1.66661 1.98478 2.12493 2.02696 2.70824C2.02696 3.24989 2.4488 3.66655 3.03938 3.66655H5.40169C6.41411 3.66655 7.00469 4.12486 7.38435 4.70818L6.92033 5.58315C6.37193 5.41649 5.78135 5.33316 5.19077 5.37482C2.32225 5.45815 0.0443025 7.74974 0.00211828 10.5413C-0.0822501 13.5829 2.36443 15.9995 5.40169 15.9995C7.89056 15.9995 9.99977 14.3329 10.6325 11.9996H14.176C14.7244 11.9996 15.1884 11.5413 15.1884 10.958C15.1041 8.9997 15.9056 7.0831 17.5507 5.74981L18.057 6.62478C16.918 7.62475 16.1587 9.08303 16.2008 10.708C16.2008 13.6245 18.6053 15.9995 21.5161 15.9995C24.5533 16.0411 27 13.6245 27 10.6246C26.9578 7.74974 24.5533 5.37482 21.6004 5.33316ZM5.40169 13.9995C3.50341 13.9995 2.02696 12.5413 2.02696 10.6663C2.02696 8.83304 3.50341 7.33309 5.40169 7.33309C5.57043 7.33309 5.73917 7.37476 5.9079 7.37476L4.17835 10.5413C3.7987 11.208 4.26272 11.9996 5.06422 11.9996H8.48114C7.93275 13.2079 6.75159 13.9995 5.40169 13.9995ZM24.933 10.8746C24.8486 12.5413 23.4565 13.9162 21.7692 13.9995C19.8287 14.1245 18.2257 12.5829 18.2257 10.6663C18.2257 9.79134 18.5632 8.9997 19.1537 8.37472L21.2208 11.8329C21.4317 12.1246 21.8113 12.2496 22.1488 12.0413L22.7394 11.7079C23.0347 11.5413 23.1612 11.1246 22.9503 10.7913L20.9255 7.41642C21.1364 7.37476 21.3473 7.37476 21.6004 7.37476C23.4987 7.33309 25.0595 8.95804 24.933 10.8746Z"
          fill="black"
        />
      </svg>
    </StyledContainer>
  );
};

export default MotorbikeSVG;
